import sortLinks from './sortLinks';
export function rootLinks(links) {
  return sortLinks(links.filter(link => !link.isChild()));
}
export function childrenOf(links, parent) {
  return sortLinks(links.filter(link => link.parent() === parent));
}
export function hasChildren(links, parent) {
  return links.some(link => link.parent() === parent);
}
flarum.reg.add('fof-links', 'common/utils/linkHierarchy', { rootLinks: rootLinks,childrenOf: childrenOf,hasChildren: hasChildren, });